import { render, staticRenderFns } from "./management.cattle.io.user.vue?vue&type=template&id=dd14970a&scoped=true&"
import script from "./management.cattle.io.user.vue?vue&type=script&lang=js&"
export * from "./management.cattle.io.user.vue?vue&type=script&lang=js&"
import style0 from "./management.cattle.io.user.vue?vue&type=style&index=0&id=dd14970a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd14970a",
  null
  
)

export default component.exports